/* global locales */
import angular from 'angular';
import moment from 'moment';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'ui-select';
import './promotionsServices';
import locales from '../../locale';

const promotionsControllers = angular.module('applicationModule.promotionsControllers', [
    'applicationModule.promotionsServices',
    'ui.bootstrap',
    'ui.select'
]);

promotionsControllers.controller('PromotionsController', ['$scope', '$rootScope', '$state', '$stateParams', '$filter', '$locale', 'NgTableParams', 'growl', 'Promotion', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, $filter, $locale, NgTableParams, growl, Promotion, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('promotions');

    $scope.app_id = $stateParams.application_id;
    $scope.check = false;
    $scope.checkedPromotions = [];
    $scope.export_date = moment().format();

    moment.locale('pl');
    $scope.search = {};


    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }


    var refresh = true;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Promotion.getList($scope.app_id, params._params).then(function (response) {
                $scope.package_id = response.packageId;
                params.total(response.promotions.total);
                params.count(response.promotions.per_page);
                params.page(response.promotions.current_page);
                return response.promotions.data;
            }).finally(function () {
                $scope.isLoading = false;
                $scope.isFind = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.isDatepickerOpen = false;

    $scope.closeCalendar = function () {
        $scope.isDatepickerOpen = false;
    };

    $scope.searchPromotions = function (search) {
        $scope.isFind = true;

        search.from_date = $filter('date')(search.from_date, 'yyyy-MM-dd');
        search.to_date = $filter('date')(search.to_date, 'yyyy-MM-dd');

        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.export = function () {
        Promotion.export($scope.export_date, $scope.app_id)
            .then(function (result) {
                let data = result.data;

                if (angular.isDefined(data.error)) {
                    growl.error(data.error);
                } else if (data) {
                    angular.openInNewTab(data);
                } else {
                    growl.error(data.error);
                }
            });
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.tags)) {
            $scope.tableParams._params.tags = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.from_date)) {
            $scope.tableParams._params.from_date = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.to_date)) {
            $scope.tableParams._params.to_date = undefined;
        }
    };

    $scope.searchTags = function (text) {
        text = $filter('removeSpecial')(text);

        Promotion.search($scope.app_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.tags = data.tags;
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.tags = [];

    $scope.copyPromotion = function (id) {
        Promotion.copyPromotion(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.COPIED');
                $state.go($state.current, {}, {reload: true});
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.COPIED');
            }
        });
    };

    $scope.removePromotion = function (id, index) {
        Promotion.remove(id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.DELETED');
            }
        });
    };

    $scope.selectPromotion = function (id) {
        $scope.checkedPromotions = angular.selectElement($scope.checkedPromotions, id);
    };

    $scope.selectAllPromotions = function (item) {
        $scope.checkedPromotions = angular.selectAllElements($scope.checkedPromotions, item);
    };

    $scope.checkSelectedPromotions = function (item) {
        return angular.checkSelectedElements($scope.checkedPromotions, item);
    };

    $scope.changeStatuses = function (status) {
        Promotion.changeStatuses($scope.checkedPromotions, status)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.CHANGE_STATUS');
                } else {
                    growl.error('MODULES.PROMOTIONS.GROWL.ERROR.CHANGE_STATUS');
                }
            })
            .catch(function () {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.CHANGE_STATUS');
            })
            .finally(function () {
                refreshData();
            });
    };

    $scope.bulkDelete = function () {
        Promotion.bulkDelete($scope.checkedPromotions)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.BULK_DELETE');
                } else {
                    growl.error('MODULES.PROMOTIONS.GROWL.ERROR.BULK_DELETE');
                }
            })
            .catch(function () {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.BULK_DELETE');
            })
            .finally(function () {
                refreshData();
            });
    };

    function refreshData() {
        $scope.searchPromotions({refresh: refresh});
        refresh = !refresh;
        $scope.checkedPromotions = [];
    }

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]).config([
    'datepickerConfig',
    'datepickerPopupConfig',
    function (datepickerConfig, datepickerPopupConfig) {
        angular.extend(datepickerConfig, {});

        angular.extend(datepickerPopupConfig, {});
    }
]);

promotionsControllers.controller('PromotionController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Promotion', '$filter', 'Permissions', '$modal', '$locale', function ($scope, $rootScope, $state, $stateParams, growl, Promotion, $filter, Permissions, $modal, $locale) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.currentTime = Date.parse(new Date());
    $scope.canBeActive = function () {
        if (angular.isNullOrUndefined($scope.promotion.from_date) && angular.isNullOrUndefined($scope.promotion.to_date)) {
            return true;
        }

        return (Date.parse($scope.promotion.to_date) > $scope.currentTime);
    };

    $scope.checkStatus = function () {
        if (!$scope.canBeActive()) {
            // $scope.promotion.status = false;
        }
    };

    $scope.writeAccess = Permissions.hasWriteAccess('promotions');

    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }


    $scope.lang = $filter('translate')('LANG');
    if (locales[$scope.lang] && locales[$scope.lang].DATETIME_FORMATS) {
        angular.copy(locales[$scope.lang].DATETIME_FORMATS, $locale.DATETIME_FORMATS);
    }

    $scope.editMode = false;
    var appId = $stateParams.application_id;
    $scope.promotion = {
        app_id: appId,
        status: true
    };
    $scope.invalidProducts = false;
    $scope.review = {};

    if (angular.isDefined($stateParams.promotionId)) {
        $scope.editMode = true;
    }

    if ($scope.editMode) {
        $scope.isLoading = true;
        Promotion.get($stateParams.promotionId, appId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.promotion = data.promotion;
                $scope.package_id = data.packageId;
                if (angular.equals($scope.promotion.products, {})) {
                    delete $scope.promotion.products;
                }
                if ($scope.promotion.types) {
                    $scope.promotion.types = $scope.promotion.types[0];
                }
                if ($scope.promotion.tags) {
                    $scope.promotion.tags = $scope.promotion.tags[0];
                }
            } else if (data.promotion === null) {
                $state.go('appsoup.application.promotions', {application_id: appId}, growl.error('MODULES.PROMOTIONS.GROWL.ERROR.NO_DATA'));
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + data.error);
            }
        }).catch(function () {
            $state.go('appsoup.application.promotions', {application_id: appId}, growl.error('ERROR.EMPTY_DATA'));
        }).finally(function () {
            $scope.isLoading = false;
            $rootScope.doingResolve = false;
        });
    }

    $scope.searchTags = function (text) {
        text = $filter('removeSpecial')(text);

        Promotion.search(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.tags = data.tags;
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.tags = [];

    $scope.changeTags = function () {
        if (angular.isDefined($scope.promotion.tags)) {
            var tempTags = [];
            angular.forEach($scope.promotion.tags, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempTags.indexOf(value) === -1) {
                    tempTags.push(value);
                }
            });
            $scope.promotion.tags = tempTags;
        }
    };

    $scope.searchTypes = function (text) {
        text = $filter('removeSpecial')(text);

        Promotion.searchTypes(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.types = data.types;
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.types = [];

    $scope.changeTypes = function () {
        if (angular.isDefined($scope.promotion.types)) {
            var tmpTypes = [];
            angular.forEach($scope.promotion.types, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tmpTypes.indexOf(value) === -1) {
                    tmpTypes.push(value);
                }
            });
            $scope.promotion.types = tmpTypes;
        }
    };

    $scope.productFilter = function (item) {
        if ($scope.promotion.products) {
            var productsIds = $scope.promotion.products.map(function (a) {
                return a.id;
            });

            return !(productsIds.indexOf(item.id) > -1);
        } else {
            return true;
        }
    };

    $scope.searchProducts = function (text) {
        text = $filter('removeSpecial')(text);

        Promotion.searchProducts(appId, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.products = data.products;
            } else {
                growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.products = [];

    $scope.checkExist = function (value) {
        return !(angular.equals(value, {}) || angular.equals(value, []) || angular.equals(value, null) || angular.equals(value, undefined));
    };

    $scope.editProduct = function (product) {
        var fileModalInstance = $modal.open({
            templateUrl: 'views/application/promotions/products/product.tpl.html',
            controller: 'PromotionProductModalController',
            backdrop: 'static',
            animation: true,
            resolve: {
                modalData: function () {
                    return {
                        productModal: product,
                        fromDate: $scope.promotion.from_date,
                        toDate: $scope.promotion.to_date
                    };
                }
            }
        });
        fileModalInstance.result.then(function (data) {
            angular.forEach($scope.promotion.products, function (val, key) {
                if (val.id == data.id) {
                    $scope.promotion.products[key] = data;
                }
            });
            if (angular.isDefined($scope.promotion.id)) {
                $scope.isLoading = true;
                Promotion.save($scope.promotion, $scope.editMode).then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.PROMOTIONS.PRODUCTS.SUCCESS.EDITED');
                    }
                }).finally(function () {
                    $scope.isLoading = false;
                });
            }
        }).catch(() => {});
    };

    $scope.removeProduct = function (key, product) {
        Promotion.updateProduct($scope.promotion.products[key].id, $stateParams.application_id)
            .then(function () {
                angular.forEach($scope.promotion.products, function (val, key) {
                    if (val.id == product.id) {
                        $scope.promotion.products.splice(key, 1);
                    }
                });
                growl.success('MODULES.PROMOTIONS.PRODUCTS.SUCCESS.DELETED');

            });
    };

    $scope.importProducts = function () {
        var fileModalInstance = $modal.open({
            templateUrl: 'views/application/promotions/components/modal/products.tpl.html',
            controller: 'PromotionProductsImportModalController',
            animation: true,
            // size: 'lg',
            backdrop: 'static',
            resolve: {
                modalData: function () {
                    return {
                        promotionId: $stateParams.promotionId
                    };
                }
            }
        });
        fileModalInstance.result.then(function () {
            $state.reload();
        }).catch(() => {});
    };

    $scope.exportProducts = function () {
        $scope.isLoading = true;
        Promotion.exportProducts($stateParams.promotionId, appId).then(function (result) {
            let data = result.data;

            if (data.error) {
                growl.error(data.error);
            } else {
                angular.openInNewTab(data);
                growl.success('GROWL.SUCCESS.EXPORT');
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.save = function () {
        $scope.productsValidation = false;
        if (!$scope.productsValidation) {
            $scope.$broadcast('show-errors-check-validity');
            $scope.isLoading = true;
            Promotion.save($scope.promotion, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $state.go('appsoup.application.promotions', {application_id: appId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        } else {
            growl.error('ERROR.REQUIRED_FIELDS_ARE_EMPTY');
        }
    };

    $scope.saveWithImport = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Promotion.save($scope.promotion, $scope.editMode).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.PROMOTIONS.GROWL.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                $state.go('appsoup.application.editPromotion', {promotionId: data.promotion.id}, {reload: true});
            } else {
                if (typeof data.error === 'object') {
                    $scope.formErrors = data.error;
                } else {
                    growl.error('MODULES.PROMOTIONS.GROWL.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                }
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.promotions', {application_id: appId});
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}],
        'from_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}],
        'to_date': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}]
    };

    var setProductDate = function (type) {
        angular.forEach($scope.promotion.products, function (value, key) {
            $scope.promotion.products[key][type] = $filter('date')($scope.promotion.products[key][type], 'yyyy-MM-dd');
        });
    };

    $scope.$watch('promotion.products', function () {
        var types = ['from_date', 'to_date'];
        var state = true;
        if ($scope.promotion.products) {
            angular.forEach(types, function (value) {
                setProductDate(value, state);
            });

            $scope.invalidProducts = false;
            angular.forEach($scope.promotion.products, function (value) {
                if (!value.promotion_price) {
                    $scope.invalidProducts = true;
                }
            });
        }
    });

    $scope.$watch('promotion.from_date', function () {
        var type = 'from_date';
        var state = true;

        $scope.promotion[type] = $filter('date')($scope.promotion[type], 'yyyy-MM-dd');

        if ($scope.promotion.products) {
            setProductDate(type, state);
        }
    });

    $scope.$watch('promotion.to_date', function () {
        var type = 'to_date';
        var state = true;

        $scope.promotion[type] = $filter('date')($scope.promotion[type], 'yyyy-MM-dd');

        if ($scope.promotion.products) {
            setProductDate(type, state);
        }
    });
}]).config([
    'datepickerConfig',
    'datepickerPopupConfig',
    function (datepickerConfig, datepickerPopupConfig) {
        angular.extend(datepickerConfig, {});

        angular.extend(datepickerPopupConfig, {});
    }
]);

promotionsControllers.controller('PromotionProductModalController', ['$scope', '$rootScope', '$stateParams', 'Promotion', '$modalInstance', 'modalData', '$filter', function ($scope, $rootScope, $stateParams, Promotion, $modalInstance, modalData, $filter) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});

    $scope.app_id = $stateParams.application_id;

    $scope.productModal = angular.copy(modalData.productModal);
    $scope.additionals = [];

    $scope.productModal.from_date = $filter('date')($scope.productModal.from_date, 'yyyy-MM-dd');
    $scope.productModal.to_date = $filter('date')($scope.productModal.to_date, 'yyyy-MM-dd');
    $scope.productModal.data = $filter('date')($scope.productModal.data, 'yyyy-MM-dd');

    $scope.changeToFloat = function (key) {
        var num = Number(parseFloat($scope.productModal[key]).toFixed(2));
        $scope.productModal[key] = angular.equals(num, NaN) ? null : num;
    };

    $scope.changeOmnibusDate = function () {
        $scope.productModal.data = $filter('date')($scope.productModal.data, 'yyyy-MM-dd');
    };

    $scope.changeDate = function (from_to) {
        $scope.productModal.from_date = $filter('date')($scope.productModal.from_date, 'yyyy-MM-dd');
        $scope.productModal.to_date = $filter('date')($scope.productModal.to_date, 'yyyy-MM-dd');
        if (angular.isDefinedNotNull($scope.productModal.to_date) && angular.isDefinedNotNull($scope.productModal.from_date)) {
            if (from_to) {
                if ($scope.productModal.from_date > $scope.productModal.to_date) {
                    $scope.productModal.to_date = $scope.productModal.from_date;
                }
            } else {
                if ($scope.productModal.to_date < $scope.productModal.from_date) {
                    $scope.productModal.from_date = $scope.productModal.to_date;
                }
            }
        }
    };

    $scope.changeActionDate = function (from_to) {
        $scope.productModal.action_from_date = $filter('date')($scope.productModal.action_from_date, 'yyyy-MM-dd');
        $scope.productModal.action_to_date = $filter('date')($scope.productModal.action_to_date, 'yyyy-MM-dd');
        if (angular.isDefinedNotNull($scope.productModal.action_to_date) && angular.isDefinedNotNull($scope.productModal.action_from_date)) {
            if (from_to) {
                if ($scope.productModal.action_from_date > $scope.productModal.action_to_date) {
                    $scope.productModal.action_to_date = $scope.productModal.action_from_date;
                }
            } else {
                if ($scope.productModal.action_to_date < $scope.productModal.action_from_date) {
                    $scope.productModal.action_from_date = $scope.productModal.action_to_date;
                }
            }
        }
    };

    $scope.changeAdditional = function () {
        if (angular.isDefined($scope.productModal.additional)) {
            var tempAdditional = [];
            angular.forEach($scope.productModal.additional, function (value) {
                value = $filter('removeSpecial')(value);
                if (angular.isDefined(value) && tempAdditional.indexOf(value) === -1) {
                    tempAdditional.push(value);
                }
            });
            $scope.productModal.additional = tempAdditional;
        }
    };

    $scope.searchAdditionals = function (search) {
        $scope.additionals = [];
        search = $filter('removeSpecial')(search);
        if (angular.isDefined(search)) {
            $scope.additionals.push(search);
        }
    };

    if ($scope.productModal) {
        $scope.changeToFloat('promotion_price');
        $scope.changeToFloat('deli_price');
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.productForm.$valid) {
            Promotion.updateProduct($scope.productModal.id, $scope.app_id)
                .then(function () {
                    $modalInstance.close($scope.productModal);
                });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'promotion_price': [{type: '$invalid', msg: 'FORM.ERRORS.REQUIRED'}]
    };
}]);

promotionsControllers.controller('PromotionProductsImportModalController', ['$scope', '$rootScope', '$stateParams', 'Promotion', 'growl', '$modalInstance', 'modalData', '$translate', function ($scope, $rootScope, $stateParams, Promotion, growl, $modalInstance, modalData, $translate) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.app_id = $stateParams.application_id;
    $scope.promotionId = modalData.promotionId;

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;
    $scope.isLoading = false;
    $scope.imported = false;
    $scope.correctProducts = [];
    $scope.wrongProducts = [];
    $scope.duplicatedProducts = [];
    $scope.mergeType = 'sap';

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
        $scope.productsNotAdded = false;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };

    $scope.changeType = function (type) {
        $scope.mergeType = type;
    };

    $scope.import = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;
        Promotion.importProducts($scope.app_id, $scope.promotionId, $scope.upload, $scope.mergeType).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.correctProducts = data.correctProducts;
                $scope.wrongProducts = data.wrongProducts;
                $scope.duplicatedProducts = data.duplicatedProducts;

                $scope.imported = true;
                if ($scope.wrongProducts.length) {
                    growl.error('MODULES.PROMOTIONS.IMPORT.ERROR');
                } else {
                    growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                }
            } else {
                var transError = 'ERROR.CONTRACTOR.' + data.error;
                $translate(transError).then(function () {
                }, function () {
                    transError = 'ERROR.UNRECOGNISED';
                }).finally(function () {
                    growl.error(transError, {title: 'MODULES.PROMOTIONS.IMPORT.HEADER'});
                });
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.close = function () {
        $modalInstance.close();
    };
}]);

promotionsControllers.controller('PromotionImportController', ['$scope', '$rootScope', '$stateParams', '$state', 'Promotion', 'growl', function ($scope, $rootScope, $stateParams, $state, Promotion, growl) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;

    $scope.requiredFields = [
        '"order"',
        '"product_id"',
        '"ean"',
        '"name"',
        '"description"',
        '"quantity_measure"',
        '"marketing_unit"',
        '"price"',
        '"deli_price"',
        '"from_date"',
        '"to_date"',
        '"fresh"',
        '"not_fresh"',
        // '"fresh_bis"',
        '"mila"',
        '"mila_dc"',
        '"new_fresh"',
        '"multipack_without_delicard"',
        '"multipack_with_delicard"',
        '"promotion"',
        '"week_promo"',
        '"action_type"'
    ];

    $scope.optionalFields = [
        '"action_title"',
        '"action_from_date"',
        '"action_to_date"',
        '"action_price"',
        '"action_description"',
        '"action_additional_description"',
        '"action_image"',
        '"action_deeplink"'
    ];

    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;
    $scope.promotionsNotAdded = [];

    $scope.getExampleXls = function () {
        $scope.isLoading = false;
        Promotion.getExampleXls().then(function (result) {
            let data = result.data;

            angular.openInNewTab(data);
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.errorRequired = false;
        $scope.fileUploaded = true;
        $scope.fileError = false;
        $scope.$apply();
    };
    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.errorRequired = true;
        $scope.fileUploaded = false;
        $scope.promotionsNotAdded = [];
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.promotions');
    };

    $scope.saveFile = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.promotionImportForm.$valid) {
            $scope.isLoading = true;
            Promotion.importPromotions($scope.application_id, $scope.upload).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.PROMOTIONS.IMPORT.SUCCESS_IMPORT');
                    $state.go('appsoup.application.promotions');
                } else {
                    growl.error(data.error, {title: 'IMPORT.HEADER.DEFAULT'});
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };
}]);

export default promotionsControllers;
